var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import { apiGetListProfessionalRfpUnRead } from '@/actions/ProfessionalMyPageRfpActions';
import { useBoolState } from '@/hooks/state/useBoolState';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * 未閲覧のプロジェクト
 * @param args
 */
export const useMyPageRfpUnread = (args) => {
    const { dispatch, isUseProffit, unmountRef } = args;
    const [data, changeData] = useState();
    const { boolState: loadingBoolState, changeFalse: loadingChangeFalse, changeTrue: loadingChangeTrue, } = useBoolState({ initialState: false });
    const { boolState: errorState, changeTrue: errorChangeTrue } = useBoolState({
        initialState: false,
    });
    // APIの読み込み
    const loadProposal = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            loadingChangeTrue();
            const response = yield wrapDispatch(dispatch, apiGetListProfessionalRfpUnRead({}, {}));
            if (!unmountRef.current) {
                changeData(response);
            }
        }
        catch (e) {
            if (!unmountRef.current) {
                errorChangeTrue();
                throw e;
            }
        }
        finally {
            if (!unmountRef.current) {
                loadingChangeFalse();
            }
        }
    }), [
        errorChangeTrue,
        loadingChangeTrue,
        loadingChangeFalse,
        unmountRef,
        dispatch,
    ]);
    // 初回ロード
    useEffect(() => {
        if (!isUseProffit) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield loadProposal();
        }))();
    }, [isUseProffit, loadProposal]);
    return {
        data,
        isError: errorState,
        loading: loadingBoolState,
    };
};
